import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import RadioButton from "components/radioButton";
import { float6Normalizer } from "validators";
import {
	applyValidatorsIf,
	floatToSixValidation,
	maxValue100,
	onlyPercentToSixFloat,
} from "validators/validation";

import styles from "./tabsChoose.module.scss";

const FlatRate = ({ setCurrentValueInField, isPaperApplication }) => {
	const handleFlatRateTemplate = () => setCurrentValueInField(true);
	return (
		<div>
			<div className={styles.subHeader}>Flat Rate</div>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "FlatRate",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Flat Rate, %"
						name="flatRate"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleFlatRateTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
			<div className={styles.addressTitle}>Pass Card Brand Fees</div>
			<Row className="mb-4">
				<Col md={12} className="d-flex">
					<Field
						component={RadioButton}
						value="true"
						className={styles.radioButton}
						name="passCardBrandFees"
						label="Yes"
						type="radio"
						id="yesPassCardBrandFees"
					/>
					<Field
						component={RadioButton}
						value="false"
						className={styles.radioButton}
						name="passCardBrandFees"
						label="No"
						type="radio"
						id="noPassCardBrandFees"
					/>
				</Col>
			</Row>
			<div className={styles.addressTitle}>Rise Free</div>
			<Row>
				<Col md={12} className="d-flex">
					<Field
						component={RadioButton}
						value="true"
						className={styles.radioButton}
						name="flatRateIsRiseFree"
						label="Yes"
						type="radio"
						id="yesFlatRateIsRiseFree"
					/>
					<Field
						component={RadioButton}
						value="false"
						className={styles.radioButton}
						name="flatRateIsRiseFree"
						label="No"
						type="radio"
						id="noFlatRateIsRiseFree"
					/>
				</Col>
			</Row>
		</div>
	);
};

export default memo(FlatRate);
